import { InfoOutlined } from "@mui/icons-material"
import OPTooltip from "components/material/tooltip"
import TooltipTitle from "./tooltip"

import "./style.scss"

interface AttributeTooltipProps {
  items: string[]
  exposures: number[]
  label: string
  currency: string | undefined
}

export default function AttributeTooltip({ items, exposures, label, currency }: AttributeTooltipProps) {
  if (!items.length) return <span>-</span>

  return (
    <OPTooltip title={<TooltipTitle {...{ label, currency, items, values: exposures }} />}>
      <span>
        {items.length > 1 && <InfoOutlined fontSize="small" />}
        {items[0]}
      </span>
    </OPTooltip>
  )
}
